import { trackingAttrs } from "@portal/components/utils";
import { ReactNode } from "react";
import { HiXMark } from "react-icons/hi2";

export const FullSubmitModalHeader = ({
	title,
	onClose,
	followersComponent,
	closeTrackingId,
}: {
	title: ReactNode;
	onClose: () => void;
	followersComponent?: React.ReactNode;
	closeTrackingId?: string;
}) => {
	return (
		<div className="flex justify-between items-center">
			<div>
				<div className="text-[13px] font-[550] text-gray-800">{title}</div>
				{followersComponent}
			</div>
			<HiXMark
				{...trackingAttrs(closeTrackingId)}
				className="cursor-pointer h-[22px] w-[22px] hover:text-secondary"
				onClick={onClose}
			/>
		</div>
	);
};
